import { IAssistantAction } from '../..';

const fixClassesAttr = 'data-intro-classes';

class HighLighter {
  originalStyle: Partial<CSSStyleDeclaration> = {};

  highlightElementByAction(action: IAssistantAction): Function {
    const unhighlightCallbacks = [];
    if ((action.element || action.hint) && !action.element.withoutHighlight) {
      const unhighlightElementCallback = this.highlightElement(
        // todo: check if we can realy remove action.hint.selector
        // $(action.element ? action.element.selector : action.hint.selector),
        action.element.HTMLElement,
        action.customStyle?.backgroundColor,
      );
      unhighlightCallbacks.push(unhighlightElementCallback);
    }
    if (action.additionalHighlightedElements) {
      const unhighlightAdditionalElementsCallbacks = action.additionalHighlightedElements.map(
        (element) =>
          this.highlightElement(
            document.querySelector<HTMLElement>(element),
            action.customStyle?.backgroundColor,
          ),
      );
      unhighlightCallbacks.push(...unhighlightAdditionalElementsCallbacks);
    }
    if (action.disablePointerEvents) {
      const revertPointerEventCallback = this.setPointerEventsToNone(
        action.element.HTMLElement,
      );
      unhighlightCallbacks.push(revertPointerEventCallback);
    }
    return function () {
      unhighlightCallbacks.forEach((cb) => cb());
    };
  }

  private setBackgroundColor(element: HTMLElement, value: string) {
    this.originalStyle.backgroundColor =
      this.originalStyle.backgroundColor ?? element.style.backgroundColor;
    element.style.backgroundColor = value;
  }

  private restoreBackgroundColor(element: HTMLElement) {
    element.style.backgroundColor = this.originalStyle.backgroundColor ?? '';
  }

  private setPointerEventsToNone(element: HTMLElement) {
    element.classList.add('tour-disable-pointer-events');

    return () => {
      element.classList.remove('tour-disable-pointer-events');
    };
  }

  private highlightElement(element: HTMLElement, backgroundColor?: string) {
    if (!element) {
      return () => {};
    }
    //%% needed parents?
    const parents = [];
    const that = this;
    element.classList.add('tour-maker-highlight-element');

    if (backgroundColor) {
      this.setBackgroundColor(element, backgroundColor);
    }

    if (window.getComputedStyle(element).position === 'static') {
      element.classList.add('tour-maker-relative-element');
    }

    let parentElm = element.parentElement;
    while (parentElm) {
      if (parentElm.tagName.toLowerCase() === 'body') {
        break;
      }
      //fix The Stacking Context problem.
      //More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
      const parentStyle = window.getComputedStyle(parentElm);
      const zIndex = parentStyle.zIndex;
      const opacity = parseFloat(parentStyle.opacity);
      const transform = parentStyle.transform;
      const willChange = parentStyle.willChange;
      const fixClasses = parentElm.getAttribute(fixClassesAttr);

      if (fixClasses) {
        const classes = (fixClasses || '')
          .split(' ')
          .map((x) => x.trim())
          .filter((x) => !!x);
        classes.forEach((x) => parentElm.classList.add(x));
        parents.push(parentElm);
      } else if (
        /[0-9]+/.test(zIndex) ||
        opacity < 1 ||
        (transform !== 'none' && transform !== undefined) ||
        willChange !== 'auto'
      ) {
        parentElm.classList.add('intro-fixparent');
        parents.push(parentElm);
      }

      parentElm = parentElm.parentElement;
    }

    //%% look for zIndex issues in the original highlight function
    return (function (_element, _parents) {
      return function () {
        that.unhighlighElement(_element, _parents);
      };
    })(element, parents);
  }

  private unhighlighElement(element: HTMLElement, parents: HTMLElement[] = []) {
    element.classList.remove('tour-maker-highlight-element');
    element.classList.remove('tour-maker-relative-element');
    element.classList.remove('tour-maker-disable-element');
    this.restoreBackgroundColor(element);

    parents.forEach((jParent) => {
      const fixClasses = jParent.getAttribute(fixClassesAttr);
      const classes = (fixClasses || '')
        .split(' ')
        .map((x) => x.trim())
        .filter((x) => !!x);
      classes.forEach((x) => x && jParent.classList.remove(x));
      jParent.classList.remove('intro-fixparent');
    });
  }
}

export default new HighLighter();
